import styled from "styled-components";
import { EAlertBlockVariant, IAlertBlockProps } from "./AlertBlock";
import { useTheme } from "../../Themes/defaultTheme";

export const _AlertBlockRoot = styled.div.attrs({
  className: "ro-alert-block",
})<Omit<IAlertBlockProps, "text">>(({ variant }) => {
  const {
    color: { yellowBg, warning, success, successBg, greyText },
  } = useTheme();
  const bgColor =
    variant === EAlertBlockVariant.WARNING
      ? yellowBg
      : variant === EAlertBlockVariant.SUCCESS
      ? successBg
      : "#f7f7f7";
  const color =
    variant === EAlertBlockVariant.WARNING
      ? warning
      : variant === EAlertBlockVariant.SUCCESS
      ? success
      : greyText;
  return {
    padding: "12px 16px 16px",
    borderRadius: 4,
    backgroundColor: bgColor,
    color,
    [".ro-typography"]: {
      color,
    },
  };
});
